// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"W1-z"};